import React from "react";
import ReplyIcon from "@material-ui/icons/Reply";

const ViewDetailsLink = ({ onClick }) => {
  return (
    <span
      onClick={(e) => {
        e.stopPropagation();
        onClick(e);
      }}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "5px",
        padding: "7px 13px",
        borderRadius: "18px",
        backgroundColor: "#fff0e9",
        color: "#e85d04",
        fontSize: "12px",
        fontWeight: 600,
        cursor: "pointer",
        whiteSpace: "nowrap",
      }}
    >
      <ReplyIcon style={{ fontSize: "16px" }} />
      Send Back
    </span>
  );
};

export default ViewDetailsLink;